import get_role_from_token from 'utils/get_role_from_token';

const initialState = {
  role: get_role_from_token(sessionStorage.getItem('token'))
};

export const SET_ROLE = '@auth/SET_ROLE';

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_ROLE:
      return { ...state, role: action.payload };
    default:
      return state;
  }
}

export const setRole = role => ({ type: SET_ROLE, payload: role });


// WEBPACK FOOTER //
// ./src/reducers/auth.js